import { AddShow } from "../components/AddShow";

export const Add = () => {
  return (
    <div className="Add">
    <h3 className="m-3">Add a new Show</h3>
      <AddShow />
    </div>
  );
};
